import { useState, useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';

import { Landing } from '@/features/User';
import { GetAuth } from '@/features/Auth/auth';

import { protectedRoutes } from './protected';
import { publicRoutes } from './public';

import { MainLayout } from '@/components/Layout';

export const AppRoutes = () => {

  /*Using UseState to manipulate auth, then program will re-render and change routes and element, not the best practice but it works*/

  const commonRoutes:RouteObject[] = [{ path: '*', element: <MainLayout><Landing /></MainLayout> }];

  const [isAuth, setIsAuth] = useState(false);
  const [finalRoutes, setFinalRoutes] = useState<RouteObject[]>(commonRoutes);

  const handleErrorAuth = (e:boolean) => {
    setIsAuth(e)
  }

  const auth = GetAuth()
  auth.then(function (result:any) {
    setIsAuth(result)
    }).catch(handleErrorAuth)

  useEffect(() => {
    const routes = isAuth ? [...protectedRoutes, ...publicRoutes] : publicRoutes
    setFinalRoutes([...routes, ...commonRoutes])
  }, [isAuth]);

  const element = useRoutes(finalRoutes)
  
  return (<>
    {element}
  </>)

};
